import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import LeaveRequestBookMakeUpSessionPage from './LeaveRequestBookMakeUpSessionPage';

// ============================================================================
// LEAVE REQUEST BOOK MAKE UP SESSION PAGE WRAPPER - GET ALL PARAMS
// ============================================================================

interface LeaveRequestBookMakeUpSessionPageWrapperProps extends WithTranslation {
  // Props will be passed through to LeaveRequestBookMakeUpSessionPage
}

const LeaveRequestBookMakeUpSessionPageWrapper: React.FC<LeaveRequestBookMakeUpSessionPageWrapperProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract all navigation parameters from URL query string (match reference navigation.getParam)
  const searchParams = new URLSearchParams(location.search);
  const state = location.state as any;
  
  // All required parameters for LeaveRequestBookMakeUpSessionPage (match reference implementation)
  const categoryId = searchParams.get('categoryId') || state?.categoryId || '';
  const code = searchParams.get('code') || state?.code || '';
  const isStudent = searchParams.get('isStudent') === 'true' || state?.isStudent || false;
  const isTherapist = searchParams.get('isTherapist') === 'true' || state?.isTherapist || false;
  
  // Navigation functions (match reference navigation object)
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      // Convert params to query string for better web parameter management
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const queryString = queryParams.toString();
      navigate(queryString ? `${path}?${queryString}` : path);
    } else {
      navigate(path);
    }
  };
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  // Debug logging for development
  if (process.env.NODE_ENV === 'development') {
    console.log('LeaveRequestBookMakeUpSessionPageWrapper - All params:', {
      categoryId,
      code,
      isStudent,
      isTherapist,
      locationState: state,
      searchParams: Object.fromEntries(searchParams.entries()),
      fullLocation: location
    });
  }
  
  return (
    <LeaveRequestBookMakeUpSessionPage
      {...props}
      // Pass all navigation parameters as props (match reference)
      categoryId={categoryId}
      code={code}
      isStudent={isStudent}
      isTherapist={isTherapist}
      location={location}
      navigate={handleNavigate}
      goBack={handleGoBack}
    />
  );
};

export default withTranslation()(LeaveRequestBookMakeUpSessionPageWrapper);
